import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { foreignRoleRedirect } from './role-areas';

/**
 * Redirects unauthenticated users to /.
 * Redirects managers to /manager — they have a separate layout and flow.
 */
export const authGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return true;
          return foreignRoleRedirect(router, status.role, ['socio']) ?? true;
        }),
      );
    }),
  );
};

/**
 * Redirects authenticated users away from public pages.
 * Managers go to /manager; socios go to /home.
 */
export const anonymousGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [true];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/home']);
          // Nadie autenticado se queda en una página pública: cada rol a su área.
          return foreignRoleRedirect(router, status.role, []) ?? router.createUrlTree(['/home']);
        }),
      );
    }),
  );
};
